<template>
	<div class="page-wrapper">
		<div class="page-breadcrumb d-flex justify-content-between">
			<h2 class="page-title">Projects</h2> 
		</div>
	</div>
</template>
<script>
export default {
  name: 'projectsView'
};
</script>
<style scoped lang="scss">

</style>
